"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityConversationRoute = exports.EntityConversationRouteDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var entity_conversation_layout_1 = require("./entity-conversation-layout");
var loading_layout_1 = require("../elements/loading-layout");
var entity_conversation_banner_1 = require("./entity-conversation-banner");
var use_dimensions_1 = __importDefault(require("../../hooks/use-dimensions"));
var use_app_layout_1 = require("../../hooks/use-app-layout");
var app_layout_context_1 = require("../context/app-layout-context");
exports.EntityConversationRouteDefaultProps = {};
// -------- Styles -------->
var BannerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: ", ";\n  "], ["\n    padding: ", ";\n  "])), theme_1.theme.UNIT(2)),
  tablet: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: ", ";\n  "], ["\n    padding: ", ";\n  "])), theme_1.theme.UNIT(3))
});
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  LoadingLayout: loading_layout_1.LoadingLayout,
  BannerContainer: styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject([""], [""]))),
  Banner: (0, styled_components_1.default)(entity_conversation_banner_1.EntityConversationBanner)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), BannerStyles),
  Layout: entity_conversation_layout_1.EntityConversationLayout
};
var EntityConversationRoute = function (props) {
  var className = props.className,
    entity = props.entity;
  var _a = __read((0, use_dimensions_1.default)(), 2),
    bannerRef = _a[0],
    bannerInfo = _a[1];
  var layoutInfo = (0, use_app_layout_1.useAppLayout)();
  var availableHeight = layoutInfo.availableHeight;
  var newLayoutInfo = __assign(__assign({}, layoutInfo), {
    availableHeight: availableHeight - (bannerInfo && bannerInfo.height || 0)
  });
  return react_1.default.createElement(My.Container, null, react_1.default.createElement(My.BannerContainer, {
    ref: bannerRef
  }, react_1.default.createElement(My.Banner, {
    entity: entity
  })), react_1.default.createElement(app_layout_context_1.AppLayoutProvider, {
    value: newLayoutInfo
  }, react_1.default.createElement(My.Layout, {
    entity: entity,
    className: className
  })));
};
exports.EntityConversationRoute = EntityConversationRoute;
exports.EntityConversationRoute.defaultProps = exports.EntityConversationRouteDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;